import {IOrdersDetails} from '@app/checkout/models/order-details.model';
import {Order} from '@app/checkout/models/order-request.model';
import {IRelatedPatientInfo} from '@app/checkout/models/patient-info.model';
import {IDynamicFormFieldType} from '@app/shared/models/dynamic.model';
import {IOrderStatus} from '@app/shared/models/orderStatus.model';
import {EActionStatus} from 'src/app/shared/enums/action-status.enum';

export interface IMyOrderState {
  myOrderDetailsStatus: EActionStatus;
  myOrderDetailsResponse: string;
  myOrderDetails: IOrdersDetails | null;
  OrderStatus: EActionStatus;
  orderStatusResponse: string;
  listOfOrderStatus: IOrderStatus[] | null;
  editOrderDetails: Order | null;
  editOrderStatus: EActionStatus;
  orderResultsPdfDetails: IOrderResultsPdfState[] | null;
  downloadOrderResultsStatus: EPdfDownloadStatus | null;
}

export interface IEditOrderState {
  created: Date;
  confirmed: Date;
  testName: string;
  days: number;
  confirmDays: number;
  barcode: string;
  statusId: number | null;
  status: string | null;
  tests: string;
  patient: string; //name
  dob: Date; // Date of birth
  sample: string;
  gender: string;
  email: string;
  phone: string;
  id: string;
  customerName: string;
  customerEmail: string;
  customerId: string;
  collectionDate: Date | undefined;
  relatedPatients: IRelatedPatientInfo[];
  clinicalHistory: IDynamicFormFieldType[];
  noGenes: number;
  geneContent: string;
  patientMedicalRecordNumber: string;
  institutionId: string;
  customerDoctorId: string;
  institutionName: string;
}

export interface IOrderResultsPdfState {
  orderResults: number;
  orderId: number;
  orderNumber: string;
  contentType: string;
  fileDownloadName: string;
}

export enum EPdfDownloadStatus {
  Initial = 'Initial',
  Success = 'Success',
  Failed = 'Failed',
}
